import { Box, Typography, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CategoryChip } from "@/components/CategoryChip";
import { TimeAgo } from "@/components/TimeAgo";
import { hr } from "@/constants/strings.hr";
import type { Article } from "@/types";

export function InFocusPanel({ article }: { article: Article }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        p: 2.5,
        backgroundColor: "action.hover",
        borderRadius: 2,
        cursor: "pointer",
      }}
      onClick={() => navigate(`/clanak/${article.id}`)}
    >
      <Typography
        variant="overline"
        sx={{
          color: "secondary.main",
          fontWeight: 700,
          letterSpacing: "0.1em",
        }}
      >
        {hr.focus.panelOverline}
      </Typography>
      <Divider sx={{ my: 1 }} />
      <CategoryChip name={article.category.name} />
      <Typography
        variant="h5"
        sx={{
          mt: 1.5,
          mb: 1,
          lineHeight: 1.3,
          "&:hover": { color: "secondary.main" },
        }}
      >
        {article.title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mb: 2,
          display: "-webkit-box",
          WebkitLineClamp: 4,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {article.subtitle}
      </Typography>
      <TimeAgo date={article.createdAt} />
    </Box>
  );
}
